import { render } from "./RequestP2PArbitrage.vue?vue&type=template&id=a1046580"
import script from "./RequestP2PArbitrage.vue?vue&type=script&lang=js"
export * from "./RequestP2PArbitrage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__